export default __webpack_public_path__ + "static/media/KOD0022-min.2085d950.webp";